import CryptoJS from "crypto-js";
// key 为 “16” 位密钥，前后端的密钥需要一致，不然加解密出来的会不一样
const key = "abcd1234ABCD1234";
/**
 * 加密 --api
 * @param word string 加密的内容
 * @returns {*} string
 */
export function Encrypt(word) {
  var secretKey = CryptoJS.enc.Utf8.parse(key); //key  为你的秘钥
  var srcs = CryptoJS.enc.Utf8.parse(word);
  var encrypted = CryptoJS.AES.encrypt(srcs, secretKey, {
    mode: CryptoJS.mode.ECB,
    padding: CryptoJS.pad.Pkcs7
  });
  return encrypted.toString();
}
/**
 * 解密 --api
 * @param word string 解密的内容
 * @returns {*} string
 */
export function Decrypt(word) {
  var secretKey = CryptoJS.enc.Utf8.parse(key);
  var decrypt = CryptoJS.AES.decrypt(word, secretKey, {
    mode: CryptoJS.mode.ECB,
    padding: CryptoJS.pad.Pkcs7
  });
  return CryptoJS.enc.Utf8.stringify(decrypt).toString();
}



// WEBPACK FOOTER //
// ./src/libs/crypto.js